/**
 * StatusBadge Component
 * Displays enrollment status as a colored badge — thin delegate to the
 * shared EnrollmentStatusPill (frontend/src/ui/EnrollmentStatusPill.tsx),
 * which owns the canonical label/color meta for this domain. Kept as its
 * own file/export so existing imports (StudyHeader.tsx, StudyList.tsx)
 * don't churn.
 */

import { EnrollmentStatusPill } from '../../ui';
import type { EnrollmentStatus } from '../types';

interface StatusBadgeProps {
  status: EnrollmentStatus;
  size?: 'sm' | 'md';
}

export function StatusBadge({ status, size = 'md' }: StatusBadgeProps) {
  return <EnrollmentStatusPill status={status} size={size} />;
}

export default StatusBadge;
